import React from "react";
import { TdsIcon } from "@tds/react";

export default function McdIcon({ icon, variant, size, classes }) {
  return <TdsIcon classes={classes} icon={icon} variant={variant} size={size} />;
}
